import { $httpChangiRecommends } from '@/core/api';
import { findByPath } from './categories-utils';
const DEFAULT_PER_PAGE_DESKTOP = 12;
const DEFAULT_PER_PAGE_MOBILE_TABLET = 12;
const MOBILE_TABLET_MQ = '(max-width: 1024px)';
const getDefaultPerPage = () => {
    // SSR-safe fallback
    if (typeof window === 'undefined')
        return DEFAULT_PER_PAGE_DESKTOP;
    return window.matchMedia(MOBILE_TABLET_MQ).matches
        ? DEFAULT_PER_PAGE_MOBILE_TABLET
        : DEFAULT_PER_PAGE_DESKTOP;
};
import { createFilters, createParams, createQueryParamsString, flatCategories, } from './categories-utils';
import { navigateWindow } from '@/router/routerUtils';
import { createPagination, } from '@/model';
import { arrayToQueryString, createBrandsQueryParamsString, mapSelectedValues, } from '../search/searchUtils';
const state = {
    menuCategories: [],
    categoriesLoaded: false,
    currentCategory: null,
    rootCategory: null,
    currentFilters: [],
    currentProducts: [],
    productsLoaded: false,
    categoryMap: {},
    categoriesLoading: false,
    filtersLoading: false,
    productsLoading: false,
    currentPage: 1,
    perPage: getDefaultPerPage(),
    total: 0,
    totalPages: 1,
    selectedBrands: [],
    sortBy: null,
    sortOrder: null,
    carouselSlug: null,
    brandSlug: null,
    basePagePath: '/category/',
    priceRanges: null,
    priceRangeFilter: [],
    availableBrands: [],
    recommendedLoading: false,
    recommended: [],
    bestsellersLoading: false,
    bestsellers: [],
    showClearFilterButton: false,
    errorMessage: null,
    freezeBrands: false,
    filterCategories: [],
    filterBrands: [],
    productTypesFilter: [],
    selectedProductTypesFilter: [],
    previousPageCategory: null,
};
// @todo rebuild function for building URL params
const mutations = {
    setFilterCategories(state, categories) {
        state.filterCategories = categories;
    },
    setAvailableBrands(state, brands) {
        state.availableBrands = brands;
    },
    setPriceRangeFilter(state, priceRange) {
        state.priceRangeFilter = priceRange;
    },
    setPriceRange(state, priceRanges) {
        state.priceRanges = priceRanges;
    },
    setBrandSlug(state, slug) {
        state.brandSlug = slug;
    },
    setCarouselSlug(state, slug) {
        state.carouselSlug = slug;
    },
    setBasePagePath(state, path) {
        state.basePagePath = path;
    },
    setCategories(state, menuCategories) {
        state.menuCategories = menuCategories;
    },
    setCategoriesLoaded(state) {
        state.categoriesLoaded = true;
    },
    setProductsLoaded(state) {
        state.productsLoaded = true;
    },
    setCurrentCategory(state, category) {
        state.currentCategory = category;
    },
    setRootCategory(state, category) {
        state.rootCategory = category;
    },
    setCategoryMap(state) {
        state.categoryMap = state.menuCategories.reduce((result, current) => {
            let topCategory = {};
            if (current.slug) {
                topCategory = {
                    [current.slug]: current,
                };
            }
            return { ...topCategory, ...result, ...flatCategories(current) };
        }, {});
    },
    setFilters(state, filters) {
        state.currentFilters = filters;
    },
    setProducts(state, products) {
        state.currentProducts = products;
    },
    setCategoriesLoading(state, loading) {
        state.categoriesLoading = loading;
    },
    setFiltersLoading(state, loading) {
        state.filtersLoading = loading;
    },
    setProductsLoading(state, loading) {
        state.productsLoading = loading;
    },
    setPagination(state, pagination) {
        const { currentPage, perPage, total, totalPages } = pagination;
        state.currentPage = currentPage;
        state.total = total;
        state.totalPages = totalPages;
        if (perPage) {
            state.perPage = perPage;
        }
    },
    setDefaultPagination(state) {
        state.currentPage = 1;
        state.perPage = getDefaultPerPage(); // <-- was DEFAULT_PER_PAGE
        state.total = 0;
    },
    setProductsPerPage(state, perPage) {
        state.perPage = perPage;
    },
    setPage(state, page) {
        state.currentPage = page;
    },
    setBrands(state, brands) {
        state.selectedBrands = brands;
    },
    freezeBrands(state, freezeBrands) {
        state.freezeBrands = freezeBrands;
    },
    setSorting(state, sorting) {
        if (typeof sorting.attribute !== 'undefined') {
            state.sortBy = sorting.attribute;
            state.sortOrder = sorting.order;
        }
        else {
            state.sortBy = null;
            state.sortOrder = null;
        }
    },
    setRecommendedLoading(state, loading) {
        state.recommendedLoading = loading;
    },
    setRecommended(state, recommended) {
        state.recommended = recommended;
    },
    setBestsellersLoading(state, loading) {
        state.bestsellersLoading = loading;
    },
    setBestsellers(state, bestsellers) {
        state.bestsellers = bestsellers;
    },
    setShowClearFilterButton(state, isFilterActive) {
        state.showClearFilterButton = isFilterActive;
    },
    setErrorMessage(state, errorMessage) {
        state.errorMessage = errorMessage;
    },
    setFilterBrands(state, brands) {
        state.filterBrands = brands;
    },
    setProductTypesFilter(state, productTypes) {
        state.productTypesFilter = productTypes;
    },
    setSelectedProductTypesFilter(state, selectedProductTypes) {
        state.selectedProductTypesFilter = selectedProductTypes;
    },
    setPreviousPageCategory(state, category) {
        state.previousPageCategory = category;
    },
};
const getters = {};
const actions = {
    getCategories({ commit }) {
        commit('setCategoriesLoading', true);
        $httpChangiRecommends.api
            .ChangiRecommendsCategoryNavigations()
            .then(({ data }) => {
            commit('setCategories', data);
            commit('setCategoryMap');
        })
            .catch((err) => {
            console.error(err);
        })
            .finally(() => {
            commit('setCategoriesLoading', false);
            commit('setCategoriesLoaded');
        });
    },
    getProducts({ commit, state, }) {
        commit('setErrorMessage', null);
        commit('setProductsLoading', true);
        const categoryUuid = state.currentCategory?.uuid;
        const filters = state.currentFilters;
        let sortingParams = {};
        let priceParams = {};
        let brandParams = {};
        let productTypeParams = {};
        const params = createParams(filters);
        const isFilterActive = JSON.stringify(params) !== '{}';
        commit('setShowClearFilterButton', isFilterActive);
        if (!categoryUuid) {
            navigateWindow('');
        }
        if (state.sortBy) {
            sortingParams = { [state.sortBy]: state.sortOrder };
        }
        if (state.priceRangeFilter &&
            state.priceRangeFilter[0] !== state.priceRangeFilter[1]) {
            priceParams.minPrice = state.priceRangeFilter[0];
            priceParams.maxPrice = state.priceRangeFilter[1];
        }
        if (state.selectedProductTypesFilter.length) {
            productTypeParams.product_sub_type = state.selectedProductTypesFilter;
        }
        if (state.selectedBrands) {
            brandParams.brandUuids = state.selectedBrands
                .filter((brand) => brand.selected)
                .map((brand) => brand.uuid);
        }
        $httpChangiRecommends.api
            .ChangiRecommendsCatalogProductsList({
            categoryUuid,
            perPage: state.perPage,
            page: state.currentPage,
            ...params,
            ...sortingParams,
            ...priceParams,
            ...brandParams,
            ...productTypeParams,
            carouselSlug: state.carouselSlug ? state.carouselSlug : undefined,
            brandSlug: state.brandSlug ? state.brandSlug : undefined,
        })
            .then(({ data }) => {
            commit('setProducts', data.data);
            const meta = data.meta;
            const paginationDto = meta.pagination;
            if (state.brandSlug) {
                let sortMetaCategories = meta.categories.sort((a, b) => a.title > b.title ? 1 : b.title > a.title ? -1 : 0);
                sortMetaCategories = sortMetaCategories.map((el) => {
                    const sortedChildrenCategories = el.children.sort((a, b) => a.title > b.title ? 1 : b.title > a.title ? -1 : 0);
                    return { ...el, sortedChildrenCategories };
                });
                commit('setFilterCategories', sortMetaCategories);
            }
            if (!state.freezeBrands) {
                const availableBrands = meta.brands;
                commit('setAvailableBrands', availableBrands);
                commit('setBrands', state.availableBrands);
            }
            commit('setFilterBrands', meta.brands);
            commit('setProductTypesFilter', meta.product_types);
            const priceRangeDto = meta.price_filter;
            const pagination = createPagination(paginationDto.current_page, paginationDto.total, paginationDto.per_page, paginationDto.total_pages);
            commit('setPriceRange', priceRangeDto);
            commit('setPagination', pagination);
        })
            .catch((err) => {
            commit('setProductsLoading', false);
            const msg = err?.response?.data?.message ??
                err?.message ??
                String(err);
            commit('setErrorMessage', msg);
            console.error(err);
        })
            .finally(() => {
            commit('setProductsLoading', false);
            commit('setProductsLoaded');
        });
    },
    getAttributes({ commit }, { categoryUuid, routeQuery, }) {
        commit('setFiltersLoading', true);
        commit('setFilters', []);
        return $httpChangiRecommends.api
            .getCategoryAttributes(categoryUuid)
            .then(({ data }) => {
            // temporary any TODO Fix types
            const filters = createFilters(data.data, routeQuery);
            if (filters && filters.length > 0) {
                filters[0].options.sort((a, b) => a.value > b.value ? 1 : b.value > a.value ? -1 : 0);
            }
            commit('setFilters', filters);
            return filters;
        })
            .catch((err) => {
            console.error(err);
            return [];
        })
            .finally(() => {
            commit('setFiltersLoading', false);
        });
    },
    getRecommended({ commit }, { categoryUuid }) {
        commit('setRecommendedLoading', true);
        // if (!state.rootCategory && !categoryUuid) {
        //   commit('setRecommended', []);
        //   commit('setRecommendedLoading', false);
        //   return Promise.resolve([]);
        // }
        const rootCategoryUuid = categoryUuid ? categoryUuid : state.rootCategory?.uuid;
        if (!rootCategoryUuid) {
            commit('setRecommended', []);
            commit('setRecommendedLoading', false);
            return Promise.resolve([]);
        }
        return $httpChangiRecommends.api
            .ChangiRecommendsRecommendedList({ category: rootCategoryUuid })
            .then(({ data }) => {
            const recommended = data.items;
            commit('setRecommended', recommended);
            return recommended;
        })
            .catch((err) => {
            console.error(err);
            return [];
        })
            .finally(() => {
            commit('setRecommendedLoading', false);
        });
    },
    getBestsellers({ commit }, { category }) {
        commit('setBestsellersLoading', true);
        const categoryUuid = category.uuid;
        return $httpChangiRecommends.api
            .ChangiRecommendsBestsellersList({ category: categoryUuid })
            .then(({ data }) => {
            const bestsellers = data.items;
            commit('setBestsellers', bestsellers);
            return bestsellers;
        })
            .catch((err) => {
            console.error(err);
            return [];
        })
            .finally(() => {
            commit('setBestsellersLoading', false);
        });
    },
    loadCategoryData({ state, commit, dispatch }, { categorySlugPath, routeQuery, brands, carouselSlug = null, brandSlug = null, }) {
        let category;
        const categorySlugs = categorySlugPath ? categorySlugPath.split('/') : [];
        if (categorySlugs?.length) {
            const { node: finalNode, root: rootCat } = findByPath(state.categoryMap, categorySlugs);
            category = finalNode;
            const rootCategory = rootCat;
            if (!category || !rootCategory) {
                navigateWindow('');
                throw new Error('There is not such category, you should not be here.');
            }
            if (routeQuery.minPrice && routeQuery.maxPrice) {
                commit('setPriceRangeFilter', [
                    routeQuery.minPrice,
                    routeQuery.maxPrice,
                ]);
            }
            else {
                commit('setPriceRangeFilter', []);
            }
            if (routeQuery.product_sub_type) {
                commit('setSelectedProductTypesFilter', Array.isArray(routeQuery.product_sub_type) ? routeQuery.product_sub_type : [routeQuery.product_sub_type]);
            }
            else {
                commit('setSelectedProductTypesFilter', []);
            }
            commit('setRootCategory', rootCategory);
            commit('setCurrentCategory', category);
            dispatch('getBestsellers', {
                category,
            });
        }
        else {
            const firstValue = state.categoryMap['popular-destinations']; // undefined if obj is empty
            commit('setRootCategory', firstValue);
            commit('setCurrentCategory', firstValue);
        }
        commit('setCarouselSlug', carouselSlug);
        commit('setBrandSlug', brandSlug);
        if (routeQuery && routeQuery.page) {
            commit('setPage', +routeQuery.page);
        }
        else {
            commit('setPage', 1);
        }
        // @todo improve after refactoring sorting parameter format
        if (routeQuery && routeQuery.date) {
            commit('setSorting', { attribute: 'date', order: routeQuery.date });
        }
        if (routeQuery && routeQuery.price) {
            commit('setSorting', { attribute: 'price', order: routeQuery.price });
        }
        if (routeQuery && routeQuery.name) {
            commit('setSorting', { attribute: 'name', order: routeQuery.name });
        }
        if (!routeQuery || (routeQuery && !(routeQuery.name || routeQuery.price || routeQuery.date))) {
            commit('setSorting', {});
        }
        if (brands) {
            const brandPayload = routeQuery.brandUuids;
            const routeQueryBrands = brandPayload
                ? Array.isArray(brandPayload)
                    ? brandPayload
                    : [brandPayload]
                : [];
            const mappedBrands = mapSelectedValues(brands, routeQueryBrands);
            commit('setBrands', mappedBrands);
            commit('setAvailableBrands', mappedBrands);
            if (routeQuery.brand) {
                commit('freezeBrands', true);
            }
            else {
                commit('freezeBrands', false);
            }
        }
        if (categorySlugs?.length && category) {
            dispatch('getAttributes', {
                categoryUuid: category.uuid,
                routeQuery,
            }).then(() => {
                dispatch('getProducts');
            });
        }
        else {
            dispatch('getProducts');
        }
    },
    changePriceFilter({ state, dispatch, commit, }) {
        // const queryParams = createQueryParamsString(state.currentFilters);
        // const brandsQuery = createBrandsQueryParamsString(state.selectedBrands);
        // const productTypesQuery = arrayToQueryString(state.selectedProductTypesFilter, 'product_sub_type');
        // const newUrl = `${window.location.origin}${
        //   window.location.pathname
        // }${queryParams}${queryParams ? '&' : '?'}minPrice=${
        //   state.priceRangeFilter[0]
        // }&maxPrice=${state.priceRangeFilter[1]}&${brandsQuery}&${productTypesQuery}`;
        commit('setPage', 1);
        // window.history.pushState({}, '', newUrl);
        // dispatch('getProducts');
        dispatch('loadNewUrl');
    },
    changeCategory({ state, dispatch, commit }, category) {
        // if (!state.currentCategory && !state.carouselSlug && !state.brandSlug) {
        //   console.log('here');
        //   return;
        // }
        let newUrl;
        const brandsQuery = createBrandsQueryParamsString(state.selectedBrands);
        commit('setDefaultPagination');
        commit('setPriceRangeFilter', []);
        commit('setSelectedProductTypesFilter', []);
        commit('setPage', 1);
        if (state.carouselSlug) {
            newUrl = `${window.location.origin}${state.basePagePath}${state.carouselSlug}/${category?.fullSlugPath ? category?.fullSlugPath : ''}`;
        }
        else if (state.brandSlug) {
            newUrl = `${window.location.origin}${state.basePagePath}${state.brandSlug}/${category?.fullSlugPath ? category?.fullSlugPath : ''}`;
        }
        else {
            newUrl = `${window.location.origin}${state.basePagePath}${category?.fullSlugPath ? category?.fullSlugPath : ''}?page=1&${brandsQuery}`;
        }
        window.history.replaceState({}, category?.title || 'Category', newUrl);
        let brandParams = {};
        if (state.selectedBrands) {
            brandParams.brandUuids = state.selectedBrands
                .filter((brand) => brand.selected)
                .map((brand) => brand.uuid);
        }
        dispatch('loadCategoryData', {
            categorySlugPath: category?.fullSlugPath,
            routeQuery: {},
            ...brandParams,
            carouselSlug: state.carouselSlug ? state.carouselSlug : null,
            brandSlug: state.brandSlug,
        });
    },
    changeFilters({ state, commit, dispatch }, filters) {
        let newUrl;
        const category = state.currentCategory;
        if (!category) {
            return;
        }
        const queryParams = createQueryParamsString(filters);
        const brandsQuery = createBrandsQueryParamsString(state.selectedBrands);
        commit('setFilters', filters);
        commit('setDefaultPagination');
        if (state.carouselSlug) {
            newUrl = `${window.location.origin}${state.basePagePath}${state.carouselSlug}/${category.fullSlugPath}${queryParams}`;
        }
        else if (state.brandSlug) {
            newUrl = `${window.location.origin}${state.basePagePath}${state.brandSlug}/${category?.fullSlugPath ? category?.fullSlugPath : ''}${queryParams}&${brandsQuery}`;
        }
        else {
            newUrl = `${window.location.origin}${state.basePagePath}${category.fullSlugPath}${queryParams}&${brandsQuery}`;
        }
        window.history.replaceState({}, category?.title || 'Category', newUrl);
        dispatch('getProducts');
    },
    changePage({ commit, dispatch, state }, page) {
        commit('setPage', page);
        // const queryParams = createQueryParamsString(state.currentFilters);
        // const newUrl = `${window.location.origin}${
        //   window.location.pathname
        // }${queryParams}${queryParams ? '&' : '?'}page=${page}`;
        // window.history.pushState({}, '', newUrl);
        // dispatch('getProducts');
        dispatch('loadNewUrl');
    },
    changeSortOrder({ commit, dispatch, state }, sorting) {
        commit('setSorting', sorting);
        // const queryParams = createQueryParamsString(state.currentFilters);
        // const newUrl = `${window.location.origin}${
        //   window.location.pathname
        // }${queryParams}${queryParams ? '&' : '?'}page=${state.currentPage}${
        //   state.sortBy ? '&' + state.sortBy + '=' + state.sortOrder : ''
        // }`;
        // window.history.pushState({}, '', newUrl);
        // dispatch('getProducts');
        dispatch('loadNewUrl');
    },
    changeProductsView({ commit, dispatch, state }, perPage) {
        commit('setProductsPerPage', perPage);
        commit('setPage', 1);
        // const queryParams = createQueryParamsString(state.currentFilters);
        // const newUrl = `${window.location.origin}${
        //   window.location.pathname
        // }${queryParams}${queryParams ? '&' : '?'}page=1`;
        // window.history.pushState({}, '', newUrl);
        // dispatch('getProducts');
        dispatch('loadNewUrl');
    },
    changeBrands({ state, commit, dispatch }, brands) {
        commit('setBrands', brands);
        commit('freezeBrands', true);
        commit('setPage', 1);
        const brandsQuery = createBrandsQueryParamsString(state.selectedBrands);
        const newUrl = `${window.location.origin}${window.location.pathname}?page=1&${brandsQuery}`;
        window.history.replaceState({}, '', newUrl);
        dispatch('getProducts');
    },
    applyProductTypesFilter({ state, commit, dispatch }) {
        commit('setPage', 1);
        dispatch('loadNewUrl');
    },
    loadNewUrl({ state, commit, dispatch }) {
        const productTypesQuery = arrayToQueryString(state.selectedProductTypesFilter, 'product_sub_type');
        const brandsQuery = createBrandsQueryParamsString(state.selectedBrands);
        const queryParams = createQueryParamsString(state.currentFilters);
        const pageQuery = `${(state.currentPage && state.currentPage > 1) ? 'page=' + state.currentPage : ''}`;
        const sortQuery = `${state.sortBy ? state.sortBy + '=' + state.sortOrder : ''}`;
        let priceRangeQuery = '';
        if (state.priceRangeFilter &&
            state.priceRangeFilter[0] !== state.priceRangeFilter[1]) {
            priceRangeQuery = `minPrice=${state.priceRangeFilter[0]}&maxPrice=${state.priceRangeFilter[1]}`;
        }
        const baseUrl = `${window.location.origin}${window.location.pathname}`;
        const queryParts = [queryParams, brandsQuery, productTypesQuery, priceRangeQuery, sortQuery, pageQuery]
            .filter(Boolean)
            .map(part => part.replace(/^\?/, ''));
        const allQuery = queryParts.join('&');
        const newUrl = baseUrl + (allQuery ? '?' + allQuery : '');
        window.history.replaceState({}, '', newUrl);
        dispatch('getProducts');
    }
};
export const categoriesModule = {
    state,
    getters,
    mutations,
    actions,
    namespaced: true,
};
